import React from "react";

const ClearSessionButton = () => {
  const handleClear = () => {
    sessionStorage.clear();
    alert("Le cache a été supprimé. Rechargez la page.");
  };

  return (
    <button onClick={handleClear}>
      Supprimer mon cache
    </button>
  );
};

export default ClearSessionButton;